import * as React from 'react';
import { deprecatedComponent } from '../react/components/core/deprecated-component.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
/**
 * @deprecated
 * use <Icon iconType="" /> instead
 **/ const IconExpand = deprecatedComponent({
    displayName: 'IconExpand',
    // @ts-ignore
    root: (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            width: "1em",
            height: "1em"
        }, props), /*#__PURE__*/ React.createElement("path", {
            d: "M11.5118 2.47607C11.0976 2.47607 10.7618 2.81186 10.7618 3.22608C10.7618 3.64029 11.0976 3.97608 11.5118 3.97608L14.9518 3.97607L10.1222 8.80561C10.1129 8.8141 10.1036 8.82288 10.0946 8.83193L3.78711 15.1394L3.78711 11.7C3.78711 11.2858 3.45132 10.95 3.03711 10.95C2.6229 10.95 2.28711 11.2858 2.28711 11.7V16.9503C2.28711 17.1492 2.36613 17.34 2.50678 17.4806C2.64743 17.6213 2.83871 17.7003 3.03762 17.7003L8.2875 17.7003C8.70171 17.7003 9.0375 17.3645 9.0375 16.9503C9.0375 16.5361 8.70171 16.2003 8.2875 16.2003L4.84752 16.2003L9.67706 11.3708C9.68645 11.3623 9.69567 11.3535 9.70473 11.3445L16.0122 5.03698L16.0122 8.47636C16.0122 8.89057 16.348 9.22636 16.7622 9.22636C17.1764 9.22636 17.5122 8.89057 17.5122 8.47636L17.5122 3.22607C17.5122 3.02716 17.4332 2.8364 17.2925 2.69574C17.1519 2.55509 16.9606 2.47607 16.7617 2.47607H11.5118Z",
            fill: "black"
        })),
    description: 'The Inline SVG Icon API is deprecated, use the Icon component instead'
});

export { IconExpand };
